import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configPromotionsView_template} from  "../components/templates/configPromotionsView_template";

declare var ko: any;
declare var page: any;

export class config_promotion_view extends vnModule_knockoutJS {

    protected elementView: configPromotionsView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {

        this.elementView = new configPromotionsView_template("config_promotion_view_template", this.viewModel, this);
        return [this.elementView.build()];
    }

    protected getModuleName(): string {

        return "config_promotions_view";
    }

    fillPage() {

        this.getReferences()
    }

    private getReferences() {

        this.loadingIn(this.elementView.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/promotion/references/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdl.execute();
    }

    private onGetReferencesReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.elementView.setPermissions(response.permissions || []);
                obj.elementView.setZones(response.zones || []);

                // get data
                obj.getDataForView();
            });
        }
    }

    private getDataForView() {

        this.loadingIn(this.elementView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/promotion/view/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetDataForViewReturn;
        this.XHRHdl.execute();
    }

    private onGetDataForViewReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setData(responseParsed.data);

            });

            obj.loadingOut(obj.elementView.builtTemplate);
        }
    }

    private setData(promotion) {

        promotion.loginStatus = (promotion.loginStatus == 'TRUE') ? "Is Logged In" : (promotion.loginStatus == 'FALSE') ? "Is Not Logged In" : "Not Applied";
        promotion.premiumStatus = (promotion.premiumStatus == 'TRUE') ? "Is Premium" : (promotion.premiumStatus == 'FALSE') ? "Is Not Premium" : "Not Applied";
        promotion.adBlockStatus = (promotion.adBlockStatus == 'TRUE') ? "Has Ad Block" : (promotion.adBlockStatus == 'FALSE') ? "Does Not Have Ad Block" : "Not Applied";
        promotion.botRequestStatus = (promotion.botRequestStatus == 'TRUE') ? "Is Bot Request" : (promotion.botRequestStatus == 'FALSE') ? "Is Not Bot Request" : "Not Applied";
        promotion.listItemStatus = (promotion.listItemStatus == 'FiveOrMoreItems') ? "Has 5 Or More Items in Lists" : (promotion.listItemStatus == 'LessThanFiveItems') ? "Has Less Than 5 Items in Lists" : "Not Applied";

        this.elementView.setPromotion(promotion);

        this.loadingOut(this.elementView.builtTemplate);
    }

    protected onClickEdit(id){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/config/promotion/edit/" + id + '/')
    }

    protected onClickCancel(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/config/promotion/")
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_promotion_view.ts